import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { Components } from 'react-markdown';

// Render assistant text as rich text. react-markdown escapes raw HTML by
// default (no dangerouslySetInnerHTML), so model output cannot inject markup.
const components: Components = {
  p: (props) => <p className="mb-2 break-words last:mb-0" {...props} />,
  ul: (props) => <ul className="mb-2 list-disc space-y-0.5 pl-4 last:mb-0" {...props} />,
  ol: (props) => <ol className="mb-2 list-decimal space-y-0.5 pl-4 last:mb-0" {...props} />,
  li: (props) => <li className="break-words" {...props} />,
  strong: (props) => <strong className="font-semibold" {...props} />,
  em: (props) => <em className="italic" {...props} />,
  a: (props) => (
    <a className="underline underline-offset-2" target="_blank" rel="noopener noreferrer" {...props} />
  ),
  code: (props) => (
    <code className="rounded bg-black/5 px-1 py-0.5 font-mono text-[0.85em]" {...props} />
  ),
  pre: (props) => (
    <pre className="mb-2 overflow-x-auto rounded bg-black/5 p-2 text-[0.85em] last:mb-0" {...props} />
  ),
  h1: (props) => <h3 className="mb-1 mt-2 text-sm font-bold first:mt-0" {...props} />,
  h2: (props) => <h3 className="mb-1 mt-2 text-sm font-bold first:mt-0" {...props} />,
  h3: (props) => <h3 className="mb-1 mt-2 text-sm font-bold first:mt-0" {...props} />,
  blockquote: (props) => (
    <blockquote className="mb-2 border-l-2 border-current/20 pl-2 italic opacity-80 last:mb-0" {...props} />
  ),
};

// `text` is an explicit prop (not JSX children) to avoid TS 5.6+'s stricter
// children-type checking on components whose children are typed as a bare string.
export function Markdown({ text }: { text: string }) {
  return (
    <div className="[word-break:break-word]">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {text}
      </ReactMarkdown>
    </div>
  );
}

export default Markdown;
